import { QuickMessageTemplate } from '../../types/types';

export interface PreviewFooterProps {
  footer: QuickMessageTemplate['footer'];
}
export function PreviewFooter({ footer }: Readonly<PreviewFooterProps>) {
  return <span>{footer}</span>;
}
